import { render } from "./audio_player.vue?vue&type=template&id=c0988104&scoped=true"
import script from "./audio_player.vue?vue&type=script&lang=js"
export * from "./audio_player.vue?vue&type=script&lang=js"

import "./audio_player.vue?vue&type=style&index=0&id=c0988104&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c0988104"

export default script